class AdaptiveHeader {
  constructor() {
    this.header = document.querySelector('.header');
    this.body = document.body;
    
    if (!this.header) return;
    
    this.init();
  }

  init() {
    // Osserva le sezioni con data-header-theme
    this.observeSections();
    
    // Gestisci anche lo scroll per il cambio logo
    this.handleScroll();
  }

  observeSections() {
    const sections = document.querySelectorAll('[data-header-theme]');

    if (sections.length === 0) return;

    // Trigger quando la sezione passa sotto l'header (più immediato e prevedibile)
    const observerOptions = {
      root: null,
      rootMargin: '-80px 0px -80% 0px', // Trigger appena la sezione passa sotto l'header
      threshold: 0
    };

    // Array per tracciare le sezioni attualmente visibili
    this.visibleSections = new Map();

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const theme = entry.target.getAttribute('data-header-theme');

        if (entry.isIntersecting) {
          // Sezione è visibile - aggiungi alla mappa con la sua posizione
          this.visibleSections.set(entry.target, {
            theme: theme,
            top: entry.boundingClientRect.top
          });
        } else {
          // Sezione non è più visibile - rimuovi dalla mappa
          this.visibleSections.delete(entry.target);
        }
      });

      // Applica il tema della sezione più in alto (più vicina al top)
      this.applyTopMostTheme();
    }, observerOptions);

    sections.forEach(section => observer.observe(section));
  }

  applyTopMostTheme() {
    if (this.visibleSections.size === 0) return;

    // Trova la sezione più in alto (con top più piccolo/negativo)
    let topMostSection = null;
    let topMostTop = Infinity;

    this.visibleSections.forEach((data, section) => {
      if (data.top < topMostTop) {
        topMostTop = data.top;
        topMostSection = data;
      }
    });

    // Applica il tema della sezione più in alto
    if (topMostSection) {
      this.updateHeaderTheme(topMostSection.theme);
    }
  }

  updateHeaderTheme(theme) {
    // Rimuovi le classi esistenti
    this.header.classList.remove('header--light', 'header--dark');
    
    // Aggiungi la nuova classe
    if (theme === 'light') {
      this.header.classList.add('header--light');
    } else if (theme === 'dark') {
      this.header.classList.add('header--dark');
    }
  }

  handleScroll() {
    let lastScroll = 0;
    
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      
      // Gestisci la classe is-at-top
      if (currentScroll <= 50) {
        this.body.classList.add('is-at-top');
      } else {
        this.body.classList.remove('is-at-top');
      }
      
      lastScroll = currentScroll;
    });
  }
}

// Inizializza quando il DOM è pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new AdaptiveHeader();
  });
} else {
  new AdaptiveHeader();
}